import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import {
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
  colorPrimary,
  fontFamilySecondary,
  colorSecondary,
  colorPrimaryLighten95,
  colorSecondaryLighten20,
  colorGrey400,
  colorAccent,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';
import { Paragraph } from '../Typography';

export const Wrapper = styled(SectionWrapper)`
  margin-top: 0;
`;

export const WrapperDatePicker = styled.div`
  & > button {
    height: 40px;
    line-height: 40px;
    width: 100%;

    @media all and ${mediaQueryMobileLargeMin} {
      width: auto;
    }
  }
`;

export const Info = styled.div`
  display: inline-block;
  color: ${({ closed }) => (closed === '1' ? colorSecondary : colorPrimary)};
  background-color: ${({ closed }) =>
    closed === '1' ? colorSecondaryLighten20 : colorPrimaryLighten95};
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  font-weight: normal;
  line-height: 27px;
  height: 28px;
  border-radius: 14px;
  padding: 0 8px;
  margin-bottom: 10px;

  &:before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
    display: inline-block;
    background-color: ${({ closed }) =>
      closed === '1' ? colorSecondary : colorPrimary};
  }
`;

export const Link = styled(CommentsLink)``;

export const HeaderMb = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: space-between;

  @media all and ${mediaQueryMobileLargeMin} {
    justify-content: space-between;
    flex-direction: row;

    & button {
      margin-top: 0;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const Title = styled.h2`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 12px;
  }
`;

export const SubTitle = styled.h1`
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorGrey400};
  font-weight: 700;
`;

export const ArchiveLink = styled(RouterLink)`
  margin-left: auto;
  color: ${colorAccent};
  font-size: 14px;
  line-height: 24px;
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  font-size: 14px;
  line-height: 24px;

  ${({ type }) =>
    type === 'average' &&
    ` 
    align-self: flex-start;

    @media all and ${mediaQueryMobileLargeMin} {
      align-self: unset;
    }
`}
`;
